module.exports = __webpack_public_path__ + "static/media/welcome-ling.9dfbfdb0.png";